
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitogoacabs() {



    const cardData =
    {
        keyword: 'Mumbai to Goa Cab Service',
        heading: 'Vedant Travels:  Mumbai to Goa Cab Service',
        headingDescription: 'Vedant Travels offers affordable and comfortable Mumbai to Goa Cabs, making your long-distance coastal journey smooth, safe, and enjoyable. With transparent fares and no hidden costs, we provide multiple cab options including Sedan, SUV, and Innova Crysta to suit your travel preferences and budget. Whether you’re planning a family vacation, a beach holiday with friends, or a business trip, our professional drivers ensure punctual pickups, safe rides, and complete convenience throughout the journey. With 24x7 availability, easy online booking, and clean, well-maintained vehicles, Vedant Travels is your trusted choice for reliable Mumbai to Goa taxi services.',

        top: 'Top Places to Visit in Goa with Vedant Travels',

"topPlaces": [
    {
        "title": "Baga Beach",
        "description": "One of Goa’s most famous beaches, Baga Beach is known for its vibrant nightlife, beach shacks, water sports, and lively crowd. It’s a must-visit for those looking for fun and adventure."
    },
    {
        "title": "Calangute Beach",
        "description": "Popularly known as the 'Queen of Beaches,' Calangute Beach offers stunning sunsets, water sports, shopping stalls, and lively beach parties."
    },
    {
        "title": "Fort Aguada",
        "description": "A 17th-century Portuguese fort, Fort Aguada offers breathtaking views of the Arabian Sea. It’s a great place for history lovers and photography enthusiasts."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "One of India’s tallest waterfalls, Dudhsagar Falls is a spectacular sight, especially during the monsoon. You can reach it via jeep safari or a trek through the lush forest."
    },
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage Site, this historic church houses the mortal remains of St. Francis Xavier. It is one of Goa’s most significant religious sites."
    },
    {
        "title": "Anjuna Flea Market",
        "description": "A paradise for shoppers, Anjuna Flea Market offers handicrafts, souvenirs, clothing, and accessories. It’s a great place to explore Goa’s local culture and art."
    },
    {
        "title": "Palolem Beach",
        "description": "A peaceful and scenic beach, Palolem Beach is perfect for those looking for a relaxing escape. You can enjoy kayaking, dolphin spotting, and beachside yoga."
    },
    {
        "title": "Chapora Fort",
        "description": "Famous for its appearance in the Bollywood movie 'Dil Chahta Hai,' Chapora Fort offers panoramic views of Vagator Beach and the Arabian Sea."
    },
    {
        "title": "Casino Royale Goa",
        "description": "Goa is known for its floating casinos, and Casino Royale Goa is among the best. Enjoy live entertainment, gaming tables, and luxurious cruise experiences."
    },
    {
        "title": "Butterfly Beach",
        "description": "A hidden gem in Goa, Butterfly Beach is known for its secluded beauty, crystal-clear waters, and breathtaking sunset views. It’s an ideal spot for couples and nature lovers."
    }
],

"services": [
    {
        "name": "Mumbai to Goa Cabs by Vedant Travels",
        "description": "Traveling from Mumbai to Goa? Book your cab with Vedant Travels for a comfortable and reliable journey. Our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride to the beautiful beaches and vibrant culture of Goa."
    },
    {
        "name": "Mumbai to Goa Taxi",
        "description": "For a hassle-free and convenient ride to Goa, choose Vedant Travels. Our taxi services are designed to provide you with a relaxing journey, making your trip from Mumbai to Goa both safe and enjoyable."
    },
    {
        "name": "Mumbai to Goa Cab Fare",
        "description": "At Vedant Travels, we offer competitive and transparent cab fares for your journey from Mumbai to Goa. We ensure that you get the best value for your money, with no hidden charges. Contact us for a detailed fare quote based on your travel specifics."
    },
    {
        "name": "Goa Trip by Taxi",
        "description": "Explore Goa in comfort with Vedant Travels. Our taxi services allow you to visit all the must-see attractions in Goa at your own pace. Whether it’s the beaches, churches, or markets, we ensure you have a stress-free experience during your Goa trip."
    },
    {
        "name": "Mumbai to Goa One Way Cab",
        "description": "If you're planning a one-way trip from Mumbai to Goa, Vedant Travels provides affordable one-way taxi services. Enjoy the convenience of a direct ride with a professional driver and well-maintained vehicle, ensuring you reach Goa without any hassles."
    },
    {
        "name": "Mumbai to Goa Innova",
        "description": "For a premium travel experience, book an Innova for your Mumbai to Goa journey. The Innova offers ample space, luxury, and comfort, making it the perfect choice for families or groups traveling together to Goa."
    },
    {
        "name": "Goa Taxi Booking",
        "description": "Booking a taxi to Goa is easy with Vedant Travels. We offer quick and simple booking options, whether you’re planning a one-way trip or a round-trip. Contact us to secure your ride and enjoy a seamless journey to Goa."
    },
    {
        "name": "Mumbai to Goa Car Hire",
        "description": "Rent a car for your trip from Mumbai to Goa with Vedant Travels. We provide flexible car hire services with a wide range of vehicle options to suit your needs, ensuring a comfortable and personalized travel experience to Goa."
    },
    {
        "name": "Mumbai to Goa Taxi Booking Online",
        "description": "Booking your taxi from Mumbai to Goa is now easier than ever with Vedant Travels’ online booking service. Reserve your ride from the comfort of your home and enjoy a hassle-free journey to Goa, with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Mumbai to Goa Round Trip",
        "description": "For a round trip from Mumbai to Goa, choose Vedant Travels for a reliable and comfortable travel experience. Our round-trip taxi services provide the flexibility you need, ensuring a smooth journey both to and from Goa."
    }
],



"tableData": [
    ["Mumbai to Goa Cabs", "Mumbai to Goa Taxi"],
    ["Mumbai to Goa Cab Fare", "Goa Trip by Taxi"],
    ["Mumbai to Goa One Way Cab", "Mumbai to Goa Innova"],
    ["Goa Taxi Booking", "Mumbai to Goa Car Hire"],
    ["Mumbai to Goa Taxi Booking Online", "Mumbai to Goa Round Trip"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of a timely trip. Whether you’re planning a relaxing getaway, a beach holiday, or a business trip, our drivers ensure that your Mumbai to Goa journey is punctual, comfortable, and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a pleasant and relaxing ride in our fleet of well-maintained, spacious vehicles. Our cars are equipped with air conditioning, ample legroom, and comfortable seating, making your long-distance journey from Mumbai to Goa a breeze."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and trained to handle long-distance trips. They are familiar with the best routes to Goa, ensuring a smooth, safe, and efficient ride. Their professional attitude ensures your journey is both comfortable and secure."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers affordable and transparent pricing for your Mumbai to Goa trip. We believe in no hidden costs, providing you with clear, upfront pricing, so you can plan your budget accordingly without any surprises."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols, ensuring your journey is worry-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you want to travel early in the morning or return late at night, Vedant Travels is available around the clock. Our customer support team is always ready to assist with your booking or any inquiries."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Goa cab is easy and convenient. You can book online through our website or mobile app, or contact our customer service team for assistance with your reservation."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel packages to suit your needs. Whether you're going for a family holiday, corporate trip, or a romantic getaway, we can tailor your Mumbai to Goa journey according to your preferences and schedule."
    }
  ]

    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Goa cab with Vedant Travels?',
            answer: 'You can book your cab online via our website or mobile app. Alternatively, you can reach out to our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced in handling long-distance trips. They are familiar with the Mumbai to Goa route, ensuring a smooth and safe journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Goa travel?',
            answer: 'We offer a range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are comfortable, spacious, and ideal for long journeys.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Goa cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip to Goa?',
            answer: 'Yes, you can book a round-trip cab for your Mumbai to Goa journey. Just provide your return details during booking, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated upfront. We ensure complete transparency and no hidden charges during or after the trip.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Goa?',
            answer: 'Yes, we offer sightseeing services as part of your Mumbai to Goa trip. Explore famous attractions like the beaches, churches, forts, and markets with a trusted driver who knows the best spots in Goa.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Goa cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or special luggage, please inform us at the time of booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Goa?',
            answer: 'Yes, we provide corporate travel services for business trips, conferences, and team outings to Goa. We ensure a comfortable and professional experience for corporate clients.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Goa travel?',
            answer: 'Vedant Travels offers reliable, comfortable, and affordable travel. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure that your Mumbai to Goa trip is smooth, safe, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Sharma",
            title: "Traveler",
            quote: "I had a wonderful experience traveling from Mumbai to Goa with Vedant Travels. The vehicle was spacious, the driver was professional, and the journey was smooth. It was a perfect start to my holiday!",
            rating: 5,
        },
        {
            name: "Mrs. Neha Patel",
            title: "Family Traveler",
            quote: "Our family had an amazing trip to Goa with Vedant Travels. The car was clean and comfortable, and the driver made sure we had a pleasant and safe journey. We will definitely choose them again for our next trip.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   
      

 const url = "https://www.vedanttravels.in/mumbai-to-goa-cabs";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/mumbai-to-goa-cabs-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block (helps rich results)
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Goa Cabs | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/mumbai-to-goa-cabs.jpg",
    "description": "Book Mumbai → Goa cabs — Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, professional chauffeurs, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 33421,          // within 8k–180k
      "reviewCount": 21904
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "7999",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Mumbai to Goa Cabs",
        "description": "Mumbai → Goa taxi booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, Amboli/Chorla ghat routes, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Mumbai to Goa Cabs", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Mumbai", "Navi Mumbai", "Thane", "Goa", "Panaji", "Calangute", "Baga", "Candolim", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 166204     // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Mumbai to Goa Cabs",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way & round-trip taxi from Mumbai/Navi Mumbai/Thane to North & South Goa — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "mumbai-goa-cabs",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "7999",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 33421,     // within 8k–180k
            "reviewCount": 21904
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Beach Holiday Trip" },
            "datePublished": "2025-07-28",
            "reviewBody": "Andheri pickup to Candolim with a breakfast stop near Kolhapur. Clean Innova and smooth ghat drive.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Family Traveler" },
            "datePublished": "2025-05-30",
            "reviewBody": "North Goa drop with return after 3 days. Fixed fare, courteous chauffeur, and clear inclusions.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is the starting fare from Mumbai to Goa?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹7999. Final fare depends on vehicle type, pickup time, route (Amboli/Chorla), and any sightseeing/waiting." }
          },
          {
            "@type": "Question",
            "name": "Which Mumbai pickup areas do you cover?",
            "acceptedAnswer": { "@type": "Answer", "text": "Entire Mumbai, Thane, and Navi Mumbai including Bandra, Andheri, BKC, Dadar, Borivali, and Vashi/Belapur/Kharghar; plus T1/T2 airport transfers." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway/highway tolls and parking included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include major tolls. Any parking/entry or extended waiting (e.g., sightseeing halts) is shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—AC, clean, GPS-enabled, with professional chauffeurs." }
          }
        ]
      }
    ]
  };





    return (
        <div>
           
                <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Mumbai to Goa Cabs | One-Way & Round Trip Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book Mumbai → Goa cabs at ₹7999 onwards. Sedan, SUV, Innova Crysta. Fixed fares, Amboli/Chorla route options, on-time pickup, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Mumbai to Goa Cabs, Mumbai to Goa Taxi, One Way Cab Mumbai Goa, Innova Mumbai to Goa, Mumbai Airport to Goa Taxi, Navi Mumbai to Goa Cab"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Mumbai to Goa Cabs | One-Way & Round Trip Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable Mumbai → Goa cabs—transparent fares, clean cars & pro drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mumbai to Goa Cabs | One-Way & Round Trip Taxi" />
        <meta name="twitter:description" content="Mumbai → Goa cabs at ₹7999 onwards. Instant confirmation, 24×7 support." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>



            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/87.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitogoacabs;